import React from 'react'
import clsx from 'clsx'

import Spacer from '../../../../atoms/Spacer'

import useStyles from './styles'

type TopRowComponentProps = {
  title: React.ReactNode
  children?: React.ReactNode
}

const TopRowComponent: React.FC<TopRowComponentProps> = ({
  title,
  children
}) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, 'topRow')}>
      <div className='title'>{title}</div>
      <Spacer /> {children}
    </div>
  )
}

export default React.memo(TopRowComponent)
